module.exports = __webpack_public_path__ + "img/news_nonoshiri.85ef675c.png";